var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.7647.486004c-.0696-.173386-.2034-.313257-.3735-.3905142-.1702-.0772575-.3635-.08595334-.5399-.0242787-.1764.0616749-.3222.1889709-.4071.3554079s-.1023.359198-.0487.538185c1.1148 3.203996-1.098 5.596796-2.7852 6.878396l-.6816-.9768c-.2292-.3276-.7416-.6-1.14-.6048l-3.8256.0168c-.4674.01412-.9222.15426-1.3164.4056l-11.27282 7.9044c-.26221.1845-.440616.4654-.496169.7812-.055552.3158.01628.6407.199769.9036l5.1228 7.3296c.384.546.9972.48 1.5444.0984l11.27282-7.9056c.324-.2292.6984-.7236.8304-1.1016l1.1976-3.774c.132-.3768.0516-.9516-.1776-1.2792l-.4152-.5952c2.2656-1.7364 4.6176-4.8048 3.312-8.559596zm-5.2452 11.229596c-.2077.1454-.442.2484-.6895.3032s-.5034.0603-.753.0161c-.2496-.0441-.4881-.137-.7018-.2733s-.3985-.3134-.5437-.5212c-.2941-.4204-.4094-.9403-.3205-1.44564.0889-.50531.3746-.95471.7945-1.24956.3291-.23062.7221-.35263 1.124-.34897s.7927.1328 1.1176.36937c-.3264.1968-.5508.312-.5928.33-.1488.07093-.269.19028-.3411.33849-.072.14822-.0916.31651-.0555.4773.0362.16079.1258.30451.2543.40771s.2883.1596.4531.1601c.1032 0 .2088-.024.3084-.0708.2328-.1104.4824-.2412.7428-.396.0599.3601.0169.7297-.1241 1.0665-.141.3367-.3742.6267-.6727.8367z",
    fill: "#000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price-icon.2bf0458cba15b7a6db2bbb5ef5b31e70.svg";
export { ForwardRef as ReactComponent };